// removed by extract-text-webpack-plugin
module.exports = {"error":"Form__error___u4Ir-"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/form/Form.css
// module id = 1176
// module chunks = 0